export enum AvailableFieldName {
  Email = 'email',
  Role = 'role',
  Balance = 'balance',
  BalanceStartWith = 'balanceStartWith',
  BalanceEndWith = 'balanceEndWith',
  Promocodes = 'promocodes',
  Amount = 'amount',
  Percentage = 'percentage',
  ExpirationDate = 'expirationDate',
  Group = 'group',
  Quantity = 'quantity',
}